import React, { FunctionComponent, useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';

import LoaderIcon from './Loader';

import { Container } from './styles';

const Loader: FunctionComponent = () => {
  const [loader, setLoader] = useState(false);

  const showLoader = useSelector((state: any) => state.loader.show);
  const msg = useSelector((state: any) => state.loader.msg);

  useEffect(() => {
    setLoader(showLoader);
  }, [showLoader]);

  return (
    <Fragment>
      {loader ? (
        <Container className="flex falign-c justify-content-c flex-dir-c">
          <div className="container-div text-center">
            <LoaderIcon />
            {msg ? <p className="mt16 font-white">{msg}</p> : null}
          </div>
        </Container>
      ) : null}
    </Fragment>
  );
};

export default Loader;
